import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useDictionaries } from 'entities/creditForm';

export const NumberOfDependents: FC<IFieldFactoryProps> = (props) => {
  const { numberOfDependentsTypes } = useDictionaries(['numberOfDependentsTypes']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={numberOfDependentsTypes}
      withCrossIcon={false}
    />
  );
};
